import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef } from 'react';
import { useIntersectionObserver, useStickyState } from '@crehana/react-hooks';
import { Alignment, Fit, Layout, useRive } from '@rive-app/react-canvas';
import cn from 'clsx';
import { URL_RIVE_ANIMATIONS_ASSET_CONFETTI_URL } from "../../../shared/constants";
import { isTestingJest } from "../../../utils/jest";
import { getArtboardRiveByLogoName } from "./utils";
import { jsx as _jsx } from "react/jsx-runtime";
var CompletedRiveAnimation = function CompletedRiveAnimation(_ref) {
  var achievementId = _ref.achievementId,
    badgeTagColor = _ref.badgeTagColor,
    _ref$forceToPlay = _ref.forceToPlay,
    forceToPlay = _ref$forceToPlay === void 0 ? false : _ref$forceToPlay,
    className = _ref.className,
    style = _ref.style;
  var _useStickyState = useStickyState(false, "isCompletedRiveAnimationPlayedFor-".concat(achievementId)),
    _useStickyState2 = _slicedToArray(_useStickyState, 2),
    isCompletedRiveAnimationPlayed = _useStickyState2[0],
    setIsCompletedRiveAnimationPlayed = _useStickyState2[1];
  var containerRef = useRef(null);
  var observer = useIntersectionObserver(containerRef, {
    threshold: 0.9,
    freezeOnceVisible: true
  });
  var _useRive = useRive({
      src: URL_RIVE_ANIMATIONS_ASSET_CONFETTI_URL,
      autoplay: false,
      layout: new Layout({
        fit: Fit.Cover,
        alignment: Alignment.Center
      }),
      useOffscreenRenderer: true,
      artboard: getArtboardRiveByLogoName(badgeTagColor)
    }),
    rive = _useRive.rive,
    RiveComponent = _useRive.RiveComponent;
  var isIntersecting = !!(observer !== null && observer !== void 0 && observer.isIntersecting);
  useEffect(function () {
    var shouldPlayAnimation = !!rive && !rive.isPlaying && (forceToPlay || isIntersecting && !isCompletedRiveAnimationPlayed);
    if (shouldPlayAnimation) {
      rive.play();
      setIsCompletedRiveAnimationPlayed(true);
    }
  }, [rive, forceToPlay, isIntersecting, isCompletedRiveAnimationPlayed, setIsCompletedRiveAnimationPlayed]);
  return /*#__PURE__*/_jsx("div", {
    ref: containerRef,
    className: cn('tw-w-full tw-h-24 tw-absolute tw-top-0 tw-left-0', className),
    style: style,
    children: !isTestingJest && /*#__PURE__*/_jsx(RiveComponent, {
      className: "tw-w-full tw-h-24"
    })
  });
};
export default CompletedRiveAnimation;